import React, {useState, useEffect} from "react";
import "../components/Blog.css";
import { useLocation } from "react-router-dom";

const BlogDetails = () => {
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Troubleshooting Guide: Clearing Cache on cPanel Server
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

                <p>
                  When websites start behaving abnormally—pages not updating, styles not loading, or slow performance—the culprit is often a full or outdated cache. If your server uses cPanel, understanding how to manage and clear cache is a vital skill. In this troubleshoot guide, we’ll walk you through the step-by-step process of clearing cache in cPanel, ensuring your website runs smoothly.
                </p>

                <img src="/graphics/images/cache.webp" alt="C Panel Password Change" />

                <h2>🧠 What Is Server Cache?</h2>
                <p>
                  Before diving into the steps, it's important to understand what caching does. Server caching stores static versions of dynamic content, such as images, scripts, and even entire HTML pages. This speeds up load times and reduces server load. However, if updates are made and cache isn’t cleared, users might not see the latest content, leading to confusion and support issues.
                </p>

                <h2>🚩 When Should You Clear Cache?</h2>

                <ol>
                  <li>Website content doesn’t reflect recent changes</li>
                  
                  <li>Stylesheets (CSS) or JavaScript files aren’t updating</li>

                  <li>Layout or design appears broken</li>
                  
                  <li>Plugins or themes in CMS platforms like WordPress aren’t functioning</li>

                  <li>After a website migration or domain change</li>
              </ol>

              <h2>🔧 Step-by-Step Guide to Clearing Cache on cPanel Server</h2>

              <p>Let’s walk through various ways to clear different types of cache using cPanel.</p>

              <h3>1. Clear Browser Cache First</h3>

              <p>Sometimes, the problem isn’t server-side. Ask users to clear their browser cache or try incognito mode. This simple step can rule out local caching issues.</p>

              <h3>2. Clear Website Cache via CMS (if applicable)</h3>

              <p>If you're using a CMS like WordPress, Joomla, or Drupal, start here:</p>

              <ol>
                  <li>WordPress: Go to your caching plugin (e.g., W3 Total Cache, WP Super Cache) and click "Empty All Caches".</li>
                  
                  <li>Joomla: Use the Cache Manager in the admin panel.</li>

                  <li>Drupal: Navigate to Configuration > Development > Performance and clear all caches.</li>

              </ol>

              <h3>3. Clear LiteSpeed Cache in cPanel</h3>

              <p>If your server uses LiteSpeed, you may have LiteSpeed Cache installed.</p>

              <ol>
                  <li>Login to cPanel</li>
                  
                  <li>Scroll down to LiteSpeed Web Cache Manager</li>

                  <li>Select the domain and click “Flush LSCache”</li>
              </ol>

              <p>Alternatively, you can add ?ls_cache_force_refresh=true at the end of a URL to force cache refresh for specific pages.</p>

              <h3>4. Clear Cache Manually via File Manager</h3>

              <p>Sometimes plugins fail. In that case:</p>

              <ol>
                  <li>Open File Manager in cPanel</li>
                  
                  <li>Navigate to your CMS directory (e.g., public_html/wp-content/cache/)</li>

                  <li>Delete files inside the cache folder</li>

              </ol>

              <p>⚠️ Be careful not to delete the cache folder itself—only its contents.</p>

              <h3>5. Clear OPcache (PHP Cache)</h3>

              <p>OPcache is a caching engine for PHP.</p>

            <ol>
                <li>Login to cPanel</li>
                
                <li>Under the Software section, click on Select PHP Version</li>

                <li>Click on Options or Extensions</li>

                <li>Disable and then re-enable OPcache</li>
            </ol>

            <p>This flushes cached PHP scripts, especially useful after updating PHP files manually.</p>

            <img src="/graphics/images/cache1.webp" alt="Cache 1" />

            <h3>6. Clear CDN Cache (If Used)</h3>

            <p>Using a CDN like Cloudflare? Make sure to purge its cache too:</p>

            <ol>
                <li>Log in to your CDN provider</li>
                
                <li>Choose the affected domain</li>

                <li>Select “Purge Everything” or purge specific URLs</li>

            </ol>
            
            <h2>🧩 Troubleshooting Common Cache Issues</h2>

            <ol>
                <li>Changes not reflecting: Ensure there’s no local DNS caching or hardcoded redirects.</li>

                <li>White screen of death: Temporarily disable plugins/themes and check cache again.</li>

                <li>Persistent old content: Check .htaccess rules or caching headers being served by the web server.</li>
            </ol>

            <h2>✅ Final Thoughts</h2>

            <p>Managing and clearing cache on a cPanel server is a critical skill in every website administrator's toolbox. This troubleshoot guide helps eliminate the guesswork when your website acts up. Whether you're flushing LiteSpeed cache, purging OPcache, or clearing out CDN data, the goal is to serve your visitors the most up-to-date content every time.</p>
        
            <p>Make it a regular practice to monitor cache health and educate your team or clients on when and why it matters.</p>
          
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
